import { render, staticRenderFns } from "./coupon-package-list.vue?vue&type=template&id=16369890&scoped=true&"
import script from "./coupon-package-list.vue?vue&type=script&lang=js&"
export * from "./coupon-package-list.vue?vue&type=script&lang=js&"
import style0 from "./coupon-package-list.vue?vue&type=style&index=0&id=16369890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16369890",
  null
  
)

export default component.exports